var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgKnowledge = function SvgKnowledge(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 0C6.15 0 4 2.15 4 4.79V28.5C4 30.43 5.57 32 7.5 32H29V0zM27 30H7.5c-.83 0-1.5-.67-1.5-1.5S6.67 27 7.5 27H27zm0-5H6V4.79C6 3.25 7.25 2 8.79 2H27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 8H10.7a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h11.6a.2.2 0 0 0 .2-.2V8.2a.2.2 0 0 0-.2-.2"
  })));
};
export default SvgKnowledge;